import React from "react";
import Select from "react-select";

const ReactDropDown = ({
  styles,
  onChange,
  isDisabled,
  selectedValue,
  pmLoading,
  performanceMetrcisResult,
  isMulti = false,
}) => {
  return (
    <Select
      styles={styles}
      isDisabled={isDisabled}
      value={selectedValue}
      pmLoading={pmLoading}
      onChange={onChange}
      options={performanceMetrcisResult}
      isOptionDisabled={(option) => option.isdisabled}
      isMulti={isMulti}
    />
  );
};

export default ReactDropDown;
